// =====================================
//
//   Change Password Controller
//   Author: Gray
//   createtime: 2016 / 09 / 02
//
// =====================================

window.InifECMobileApp.controller("ChangePwdController", ['$scope', '$state', '$timeout', '$rootScope', 'UserService', 'BusinessMemberService',
	function($scope, $state, $timeout, $rootScope, UserService, BusinessMemberService) {
        
        var init = function() {

            $scope.isLoading = true;

            UserService.getUserInfo().then(function(result) {
                $scope.isLoading = false;
                $scope.user = result;

                checkIsBusinessMember();

            }, function(error) {
                $scope.isLoading = false;
            });
        }

        var checkIsBusinessMember = function() {

            $scope.isBusinessMember = false;

            if($scope.user.membertype == 1 && $scope.user.businessmrscid) {
                $scope.isBusinessMember = true;
                $scope.user.isNoPassword = false; // 企業用戶一定有密碼
            }
        }

        var submit = function() {

            if($scope.isBusinessMember) {
                updBusinessMemberPassword();
            } else {
                if($scope.user.isNoPassword) {
                    setPwd();
                } else {
                    changePwd();
                }
            }
        }

        var changePwd = function() {

            if ($scope.isUpdating) {
                return;
            }

            $scope.isError = false;
            $scope.isPwdEmpty = false;
            $scope.isRePwdEmpty = false;
            $scope.isCheckError = false;
            $scope.isOldPwdEmpty = false;

            if (!$scope.form.oldpwd) {
                $scope.isOldPwdEmpty = true;
            }

            if (!$scope.form.pwd) {
                $scope.isPwdEmpty = true;
            }

            if (!$scope.form.repwd) {
                $scope.isRePwdEmpty = true;
            }

            if ($scope.form.pwd && $scope.form.repwd &&
                $scope.form.pwd != $scope.form.repwd) {
                $scope.isCheckError = true;
            }

            if ($scope.isOldPwdEmpty || $scope.isPwdEmpty || $scope.isRePwdEmpty || $scope.isCheckError) {
                return;
            }

            $scope.isPasswordFailed = false;
            $scope.isUpdating = true;

            UserService.updPassword($scope.form.oldpwd, $scope.form.pwd).then(function(result) {
                if (result) {
                    $scope.form.oldpwd = '';
                    $scope.form.pwd = '';
                    $scope.form.repwd = '';
                    $scope.isUpdating = false;

                    $rootScope.$broadcast('OPEN_LOADING_SUCCESS_MODAL', {
                        title: '成功修改密碼',
                    });

                } else {

                    $scope.isError = true;
                    $scope.isUpdating = false;

                    $rootScope.$broadcast('OPEN_LOADING_ERROR_MODAL', {
                        title: '系統發生錯誤',
                    });
                }
            }, function(error) {
                $scope.isError = true;
                $scope.isUpdating = false;

                if(error.code == "error.formValidator.passwordFailed" ){
                    $scope.isPasswordFailed = true;
                } 
                else {
                    $rootScope.$broadcast('OPEN_LOADING_ERROR_MODAL', {
                        title: '系統發生錯誤',
                    });
                }
            });
        }

        var setPwd = function() {

            if ($scope.isUpdating) {
                return;
            }
            $scope.isError = false;
            $scope.isPwdEmpty = false;
            $scope.isRePwdEmpty = false;
            $scope.isCheckError = false;

            if (!$scope.form.pwd) {
                $scope.isPwdEmpty = true;
            }

            if (!$scope.form.repwd) {
                $scope.isRePwdEmpty = true;
            }

            if ($scope.form.pwd && $scope.form.repwd &&
                $scope.form.pwd != $scope.form.repwd) {
                $scope.isCheckError = true;
            }

            if ($scope.isPwdEmpty || $scope.isRePwdEmpty || $scope.isCheckError) {
                return;
            }

            $scope.isUpdating = true;
            
            UserService.setPassword($scope.form.pwd).then(function(result) {
                if (result) {
                    $scope.form.oldpwd = '';
                    $scope.form.pwd = '';
                    $scope.form.repwd = '';

                    $scope.isUpdating = false;
                    $scope.user.isNoPassword = false;

                    $rootScope.$broadcast('OPEN_LOADING_SUCCESS_MODAL', {
                        title: '成功設定密碼',
                    });
                } else {
                    $scope.isError = true;
                    $scope.isUpdating = false;
                    
                    $rootScope.$broadcast('OPEN_LOADING_ERROR_MODAL', {
                        title: '系統發生錯誤',
                    });
                }     
            }, function(error) {
                $scope.isError = true;
                $scope.isUpdating = false;

                $rootScope.$broadcast('OPEN_LOADING_ERROR_MODAL', {
                    title: '系統發生錯誤',
                });
            });
        }

        var updBusinessMemberPassword = function() {

            if ($scope.isUpdating) {
                return;
            }
            $scope.isError = false;
            $scope.isPwdEmpty = false;
            $scope.isRePwdEmpty = false;
            $scope.isCheckError = false;
            $scope.errorMsg = "";

            if (!$scope.form.oldpwd) {
                $scope.isoldPwdEmpty = true;
            } else {
                $scope.isoldPwdEmpty = false;
            }

            if (!$scope.form.pwd) {
                $scope.isPwdEmpty = true;
            } else {
                $scope.isPwdEmpty = false;
            }

            if (!$scope.form.repwd) {
                $scope.isRePwdEmpty = true;
            } else {
                $scope.isRePwdEmpty = false;
            }

            if ($scope.form.pwd && $scope.form.repwd &&
                $scope.form.pwd != $scope.form.repwd) {
                $scope.isCheckError = true;
            }

            if ($scope.isoldPwdEmpty || $scope.isPwdEmpty || $scope.isRePwdEmpty || $scope.isCheckError) {
                return;
            }

            $scope.isPasswordFailed = false;
            $scope.isUpdating = true;

            BusinessMemberService.updatePassword($scope.form.oldpwd, $scope.form.pwd).then(function(result) {
                if (result) {
                    $scope.form.oldpwd = '';
                    $scope.form.pwd = '';
                    $scope.form.repwd = '';

                    $scope.isUpdating = false;

                    $rootScope.$broadcast('OPEN_LOADING_SUCCESS_MODAL', {
                        title: '成功修改密碼',
                    });
                } else {
                    $scope.isError = true;
                    $scope.isUpdating = false;
                    
                    $rootScope.$broadcast('OPEN_LOADING_ERROR_MODAL', {
                        title: '系統發生錯誤',
                    });
                }                
            }, function(error) {
                $scope.isError = true;
                $scope.isUpdating = false;

                if(error.code == "error.formValidator.passwordFailed" ){
                    $scope.isPasswordFailed = true;
                } 
                else {
                    $rootScope.$broadcast('OPEN_LOADING_ERROR_MODAL', {
                        title: '系統發生錯誤',
                    });
                }
            });
        }

        //==========================
        //  Events
        //==========================

        //==========================
        //  Members
        //==========================
        
        $scope.form = {
            oldpwd: '',
            pwd: '',
            repwd: ''
        }

        $scope.isLoading = false;
        $scope.isUpdating = false;
        $scope.isError = false;
        $scope.isOldPwdEmpty = false;
        $scope.isPwdEmpty = false;
        $scope.isRePwdEmpty = false;
        $scope.isCheckError = false;
        $scope.isPasswordFailed = false;
        $scope.user = undefined;
        $scope.isBusinessMember = false;

        //==========================
        //  Methods
        //==========================
        $scope.submit = submit;

        //==========================
        //  Init
        //==========================
        init();
	}
]);